// ANCHOR React
import { memo } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Components
import { LyonRestrictedTitle } from './LyonRestrictedTitle';
import { LyonRestrictedDescription } from './LyonRestrictedDescription';
import { LyonRestrictedLink } from './LyonRestrictedLink';

// ANCHOR Styles
import { BLOCK, CENTER } from './styles';

interface ILyonRestrictedInfoProps {
  auth?: boolean;
  actionButton?: React.ReactNode;
  isCenter?: boolean;
}

export const LyonRestrictedInfo = memo(({
  auth, actionButton, isCenter,
}: ILyonRestrictedInfoProps) => (
  <Block overrides={isCenter ? CENTER : BLOCK}>
    <LyonRestrictedTitle isCenter={isCenter} />
    <LyonRestrictedDescription isCenter={isCenter} />
    {auth && <LyonRestrictedLink />}
    {actionButton}
  </Block>
));
